import { CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useTran } from "@/hooks";

const SUMMARY_TEXT_CLASS = {
  success: "text-green-600 dark:text-green-400",
  muted: "text-muted-foreground",
};

const SUMMARY_BADGE_CLASS = {
  success:
    "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  muted: "bg-muted text-muted-foreground",
};

const ROW_STATUS_CLASS = {
  new: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
  update:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
};

export const BatchUploadSummaryItems = ({ items = [], variant = "text" }) => {
  const { t } = useTran();
  const asBadge = variant === "badge";

  return items.map((item) =>
    asBadge ? (
      <Badge
        key={item.key}
        variant="secondary"
        className={SUMMARY_BADGE_CLASS[item.tone]}
      >
        {t(item.label, { count: item.count })}
      </Badge>
    ) : (
      <span
        key={item.key}
        className={`inline-flex items-center gap-1 ${SUMMARY_TEXT_CLASS[item.tone]}`}
      >
        <CheckCircle2 size={14} />
        {t(item.label, { count: item.count })}
      </span>
    ),
  );
};

export const BatchUploadRowStatusBadge = ({ action }) => {
  const { t } = useTran();
  const normalizedAction = action === "update" ? "update" : "new";

  return (
    <Badge variant="secondary" className={ROW_STATUS_CLASS[normalizedAction]}>
      {normalizedAction === "update" ? t("Update") : t("New")}
    </Badge>
  );
};
